type ConditionalWrapperType = {
  condition: boolean;
  wrapper: (children: JSX.Element) => JSX.Element;
  falseWrapper?: (children: JSX.Element) => JSX.Element;
  children: JSX.Element;
};

export const ConditionalWrapper = ({
  condition,
  wrapper,
  falseWrapper,
  children,
}: ConditionalWrapperType): JSX.Element =>
  condition
    ? wrapper(children)
    : falseWrapper
    ? falseWrapper(children)
    : children;
